import React, { useState } from "react";
import { Avatar, Badge, Toggle } from "@opendate-app/setlist";

import { useBroadcastEditContext } from "../BroadcastEditContainer";
import { senderLabel } from "./smsMessage";

const styles = {
  wrap: { width: "100%", maxWidth: 340, margin: "0 auto", padding: "32px 0", display: "flex", flexDirection: "column", gap: 12 },
  bar: { display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: 14, color: "var(--sl-text-secondary)" },
  phone: {
    borderRadius: 44,
    border: "10px solid var(--sl-bg-primary-solid)",
    boxShadow: "0 0 0 1px var(--sl-border-primary)",
    background: "var(--sl-bg-primary)",
    minHeight: 480,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  island: { alignSelf: "center", width: 72, height: 20, marginTop: 8, borderRadius: 10, background: "var(--sl-bg-primary-solid)" },
  thread: { display: "flex", flexDirection: "column", alignItems: "center", gap: 4, padding: "12px 16px", borderBottom: "1px solid var(--sl-border-secondary)", fontSize: 12, color: "var(--sl-text-tertiary)" },
  messages: { flex: 1, padding: 16, display: "flex", flexDirection: "column", gap: 8 },
  stamp: { textAlign: "center", fontSize: 11, color: "var(--sl-text-quaternary)" },
  bubble: { alignSelf: "flex-start", maxWidth: "85%", padding: "8px 12px", borderRadius: 18, background: "var(--sl-bg-tertiary)", color: "var(--sl-text-primary)", fontSize: 14, lineHeight: "20px", whiteSpace: "pre-wrap", overflowWrap: "anywhere" },
  empty: { border: "1px dashed var(--sl-border-primary)", borderRadius: "var(--radius-xl)", padding: 16, fontSize: 13, color: "var(--sl-text-tertiary)", textAlign: "center" },
};

const PhonePreview = ({ draft, rendered, fanCount }) => {
  const { recipientsCount, broadcast, twilioMessagingServices } = useBroadcastEditContext();
  const [sampleFan, setSampleFan] = useState(true);
  const sender = twilioMessagingServices?.find((service) => service.id === broadcast.twilio_template?.twilio_messaging_service_id);
  const body = sampleFan ? (rendered.text ?? draft) : draft;

  return (
    <div style={styles.wrap}>
      <div style={styles.bar}>
        <span>Phone preview</span>
        <Badge size="sm" color="gray">{fanCount ?? recipientsCount} fans</Badge>
      </div>
      <Toggle label="Fill in with a sample fan" checked={sampleFan} onChange={(event) => setSampleFan(event.target.checked)} />
      <div style={styles.phone}>
        <div style={styles.island} aria-hidden="true" />
        <div style={styles.thread}>
          <Avatar size="sm" initials={(sender?.name || "?").replace(/\W/g, "").charAt(0) || "?"} alt={sender?.name || ""} />
          <span>{sender ? senderLabel(sender) : "No sender picked"}</span>
        </div>
        <div style={styles.messages}>
          <div style={styles.stamp}>Text Message</div>
          {draft?.trim()
            ? <div style={styles.bubble}>{body}</div>
            : <div style={styles.empty}>Your text shows up here once you write it in Message.</div>}
        </div>
      </div>
    </div>
  );
};

export default PhonePreview;
